import React from "react";
import Flashcard from "../shared/Flashcard";
import { motion } from "framer-motion";

const QuizCardsContainer = () => {
  return (
    <div className="relative w-[328px] h-[274px] bg-white rounded-[28px] overflow-hidden border border-dashed border-black">
      {/* Take a quiz button */}
      <motion.div
        className="inline-flex items-center justify-center px-4 py-2 absolute top-[19px] left-[21px] bg-black rounded-[20px] cursor-pointer"
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 400, damping: 10 }}
      >
        <div className="font-extrabold text-white text-xs">Take a quiz</div>
      </motion.div>

      {/* Flashcards stack */}
      <div className="absolute w-full h-full top-[93px] flex items-center justify-center">
        <div className="relative w-[364px] h-[312px]">
          {/* Biology Card */}
          <motion.div
            className="absolute left-[90px] top-[35px]"
            style={{ rotate: "18.86deg" }}
            whileHover={{ scale: 1.02, y: -5 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
          >
            <Flashcard
              question="What type of macromolecule are enzymes?"
              hint="Made of amino acids."
              subject="Biology"
              color="#DAB2FF"
              subjectColor="#E5E7EB"
            />
          </motion.div>

          {/* Computer Science Card */}
          <motion.div
            className="absolute left-[30px] top-[5px]"
            style={{ rotate: "2.99deg" }}
            whileHover={{ scale: 1.02, y: -5 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
          >
            <Flashcard
              question="What is the difference between HTTP and HTTPS?"
              hint="One includes encryption for security."
              subject="Computer Science"
              color="#FFD230"
              subjectColor="#E5E7EB"
            />
          </motion.div>

          {/* Physics Card */}
          <motion.div
            className="absolute left-[25px] top-[40px]"
            style={{ rotate: "-11.90deg" }}
            whileHover={{ scale: 1.02, y: -5 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
          >
            <Flashcard
              question="What is the speed of light in a vacuum?"
              hint="Approximately 3.0 × 10⁸ m/s."
              subject="Physics"
              color="#FF6467"
              subjectColor="#E5E7EB"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

const PractiseFeatureCard = () => {
  return (
    <div className="bg-[#F4A8FF] rounded-[32px] w-[300px] h-[500px] sm:w-[330px] sm:h-[550px] md:w-[360px] md:h-[600px] py-6 flex flex-col relative items-center border border-black border-dashed overflow-hidden">
      <h2 className="text-black text-[24px] sm:text-[26px] md:text-[28px] font-bold text-center mb-6 sm:mb-8">
        Practice
      </h2>

      <div className="absolute top-1/2 left-[60%] -translate-x-1/2 -translate-y-1/2">
        <QuizCardsContainer />
      </div>
    </div>
  );
};

export default PractiseFeatureCard;
